import {OrderClaimInfoState} from '../interfaces'

export const getInitialState = (): OrderClaimInfoState => ({
    status: 'ENABLE',
    summary: {
        type: 'RETURN',
        amount: 0,
    },
    claimDetail: {
        status: 'ENABLE',
        title: '',
        amount: 0,
        items: [],
    },
    claimReason: {
        status: 'ENABLE',
        items: [],
    },
})
